var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilvershield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68285 3.71167H36.3148C40.4144 3.71167 43.7378 7.03509 43.7378 11.1348V28.632C43.7378 40.0525 34.4798 49.3106 23.0592 49.3106H20.9383C9.51788 49.3106 0.259766 40.0525 0.259766 28.632V11.1348C0.259766 7.03509 3.5832 3.71167 7.68285 3.71167Z",
    fill: "#AAC1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8523 3.71167H36.3151C40.4148 3.71167 43.7382 7.03509 43.7382 11.1348V15.8195L12.1856 47.3721C5.32861 44.1639 0.522181 37.3029 0.270508 29.2935L25.8523 3.71167Z",
    fill: "#C2D1DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68383 0H36.3157C40.4154 0 43.7388 3.32343 43.7388 7.42308V25.9808C43.7388 36.8156 34.9555 45.5989 24.1206 45.5989H19.8789C9.04409 45.5989 0.260742 36.8156 0.260742 25.9808V7.42308C0.260742 3.32343 3.58418 0 7.68383 0Z",
    fill: "#C2D1DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68383 4.77198C6.21966 4.77198 5.03273 5.95892 5.03273 7.42308V25.9808C5.03273 34.1801 11.6795 40.827 19.8789 40.827H24.1206C32.32 40.827 38.9668 34.1801 38.9668 25.9808V7.42308C38.9668 5.95892 37.7799 4.77198 36.3157 4.77198H7.68383ZM7.68383 0H36.3157C40.4154 0 43.7388 3.32343 43.7388 7.42308V25.9808C43.7388 36.8156 34.9555 45.5989 24.1206 45.5989H19.8789C9.04409 45.5989 0.260742 36.8156 0.260742 25.9808V7.42308C0.260742 3.32343 3.58418 0 7.68383 0Z",
    fill: "#D6E4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5649 0H36.3162C40.4159 0 43.7393 3.32343 43.7393 7.42308V15.8195L14.6613 44.8974C7.32371 42.8778 1.70762 36.7035 0.501953 29.063L29.5649 0Z",
    fill: "#D1DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03321 24.5318V25.9808C5.03321 33.8077 11.0901 40.22 18.7724 40.7863L14.6613 44.8974C7.32371 42.8778 1.70762 36.7035 0.501953 29.063L5.03321 24.5318ZM38.9673 20.5914V7.42308C38.9673 5.95892 37.7804 4.77198 36.3162 4.77198H24.7929L29.5649 0H36.3162C40.4159 0 43.7393 3.32343 43.7393 7.42308V15.8195L38.9673 20.5914Z",
    fill: "#E0EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7687 24.0958C17.462 23.1652 16.6162 21.6798 16.6162 20.0064C16.6162 17.188 19.0151 14.9033 21.9744 14.9033C24.9336 14.9033 27.3325 17.188 27.3325 20.0064C27.3325 21.7135 26.4523 23.2248 25.1006 24.1513L26.4728 27.7431C26.8422 28.7098 26.2883 29.7685 25.2356 30.1078C25.0206 30.177 24.7945 30.2123 24.5668 30.2123H19.2814C18.1658 30.2123 17.2613 29.3818 17.2613 28.3572C17.2613 28.1481 17.2999 27.9405 17.3753 27.7431L18.7687 24.0958Z",
    fill: "#8097AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_21950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.4783,
    height: 50,
    fill: "white",
    transform: "translate(0.260742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilvershield);
export default __webpack_public_path__ + "static/media/silvershield.4319a68c2a94f15cb667626b681f07aa.svg";
export { ForwardRef as ReactComponent };